import React from 'react';
import {Outlet} from 'react-router-dom';

const Securitygroup: React.FC = () => {
  return <Outlet />;
};
export default Securitygroup;
